var map = {
	"./release-v0.10.0.md": "./src/features/Releases/entries/release-v0.10.0.md",
	"./release-v0.10.1.md": "./src/features/Releases/entries/release-v0.10.1.md",
	"./release-v0.10.10.md": "./src/features/Releases/entries/release-v0.10.10.md",
	"./release-v0.10.11.md": "./src/features/Releases/entries/release-v0.10.11.md",
	"./release-v0.10.12.md": "./src/features/Releases/entries/release-v0.10.12.md",
	"./release-v0.10.13.md": "./src/features/Releases/entries/release-v0.10.13.md",
	"./release-v0.10.14.md": "./src/features/Releases/entries/release-v0.10.14.md",
	"./release-v0.10.15.md": "./src/features/Releases/entries/release-v0.10.15.md",
	"./release-v0.10.16.md": "./src/features/Releases/entries/release-v0.10.16.md",
	"./release-v0.10.17.md": "./src/features/Releases/entries/release-v0.10.17.md",
	"./release-v0.10.2.md": "./src/features/Releases/entries/release-v0.10.2.md",
	"./release-v0.10.3.md": "./src/features/Releases/entries/release-v0.10.3.md",
	"./release-v0.10.4.md": "./src/features/Releases/entries/release-v0.10.4.md",
	"./release-v0.10.5.md": "./src/features/Releases/entries/release-v0.10.5.md",
	"./release-v0.10.6.md": "./src/features/Releases/entries/release-v0.10.6.md",
	"./release-v0.10.7.md": "./src/features/Releases/entries/release-v0.10.7.md",
	"./release-v0.10.8.md": "./src/features/Releases/entries/release-v0.10.8.md",
	"./release-v0.10.9.md": "./src/features/Releases/entries/release-v0.10.9.md"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/features/Releases/entries sync release-v.*\\.md$";